import React, { useEffect, useState } from 'react';
import Layout from './components/Layout';
import LiquidationTable from './components/LiquidationTable'
import axios from 'axios';
// import WithdrawalStatusUpdateDialog from './components/WithdrawalStatusUpdateDialog';
import LiquidationStatusUpdateDialog from './components/LiquidationStatusUpdateDialog';
import InputBase from '@mui/material/InputBase';
import SearchIcon from '@mui/icons-material/Search';
import InputAdornment from '@mui/material/InputAdornment';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
const SDM_PAY_HOST = process.env.REACT_APP_SDM_PAY_BE
interface Liquidation {
    id: string;
    userId: string;
    transferId: string;
    amount: string;
    currency: string;
    fiatAmount: string;
    fiatCurrency: string;
    status: string;
    substatus: string;
    amountOnHold: string;
    fiatOnHold: string;
    proofOfTransaction: string;
    createdAt: string;
    settledAt: string | null;
    updatedAt: string;
}
interface ClientData {
    Liquidations: Array<Liquidation>;
    cad_balance: number;
    createdAt: string;
    email: string;
    id: string;
    nickname: string;
    updatedAt: string;
    usd_balance: number;
    usdc_wallet: string;
    usdt_wallet: string;
}
function Liquidations({isAdmin}: any) {
    const [data, setData] = useState<ClientData[]>([])
    const [openStatusUpdate, setOpenStatusUpdate] = useState(false);
    const [selectedRequest, setSelectedRequest] = useState<Liquidation>();
    const [update, setUpdate] = useState(0);
    const [searchTXValue, setSearchTXValue] = useState(''); 
    useEffect(() => {
        getLiquidationReuests()
    },[update, searchTXValue])
    const getLiquidationReuests = async() : Promise<any[]> => {
        try {
            // create sig

            // const timeStamp = moment().seconds(0).milliseconds(0).toISOString().slice(0, -1) + "000Z"
            // const path = '/api/getB2C2Trades' 

            // const signature = generateSignature("GET", timeStamp, path, null, null) 
            // console.log("get b2c2 trades sig", signature)

            const result = await axios.get(SDM_PAY_HOST + '/getLiquidations')
            console.log(result)
            let resultJSONData = result.data
            console.log(resultJSONData)
            if(searchTXValue){
                console.log(searchTXValue)
                resultJSONData = resultJSONData.filter((user:any) => user.email.toUpperCase().includes(searchTXValue.toUpperCase()))
                console.log(resultJSONData)
            }
            setData(resultJSONData)
            return resultJSONData
        }
        catch (err) {
            alert(err)
            return []
        }
    }
    const handleSelectRequestToUpdate = (request: Liquidation) => {
        setSelectedRequest(request)
        setOpenStatusUpdate(true)
    }
    const handleSearchTXclient = (e:any) => {
        let inputValue = (e.target.value).trim()
        setSearchTXValue(inputValue)
    }
    const handleClickClearTransactionSearchInput = () => {
        setSearchTXValue('')
    }
    return (
        <Layout>
            <div style={{width: '100%',marginTop: 30}}>
                <Paper
                    component="form"
                    sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: 200, height: 36 ,marginBottom: 1, marginRight: 5 }}
                >
                    <InputBase
                        sx={{ ml: 1, flex: 1 }}
                        value={searchTXValue}
                        onChange={(e) => handleSearchTXclient(e)}
                        placeholder="Search User"
                        inputProps={{ 'aria-label': 'search client' }}
                        endAdornment={searchTXValue? 
                            <InputAdornment position="end">
                                <IconButton
                                    size='small'
                                    onClick={handleClickClearTransactionSearchInput}
                                    style={{borderRadius: 0}}
                                >
                                    <CloseIcon />
                                </IconButton>
                            </InputAdornment> : <SearchIcon />}
                    />
                </Paper>
                <LiquidationTable data={data} update={update} setUpdate={setUpdate} handleSelectRequestToUpdate={handleSelectRequestToUpdate} isAdmin={isAdmin}/>
                {selectedRequest && <LiquidationStatusUpdateDialog open={openStatusUpdate} handleClose={() => setOpenStatusUpdate(false)} liquidationRequest={selectedRequest} update={update} setUpdate={setUpdate}/>}
            </div>
        </Layout>
    );
}

export default Liquidations;